<svg
  width="36"
  height="36"
  viewBox="0 0 36 36"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
></svg>;
import { createIcon, Svg } from "@gluestack-ui/icon";
import { Path } from "react-native-svg";

const LiquidIcon = createIcon({
  Root: Svg,
  viewBox: "0 0 36 36",
  path: (
    <>
      <Path
        d="M11.4695 6.20848C11.3651 6.04197 11.1241 6.03949 11.0172 6.20351C9.9038 7.91088 6.24552 11.1342 6.01936 14.1091C5.75592 17.581 8.21632 19.4126 11.2458 19.4126C14.2753 19.4126 16.6239 17.0963 16.3977 14.0718C16.1716 11.0473 12.5729 7.99786 11.4695 6.20848Z"
        fill="none"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M27.4052 4.06555C27.353 3.97857 27.2288 3.97857 27.1716 4.06307C26.6 4.94036 24.7212 6.59553 24.6044 8.12396C24.4677 9.90587 25.7327 10.8478 27.2884 10.8478C28.8442 10.8478 30.052 9.65735 29.9327 8.10407C29.8159 6.55825 27.9694 4.98509 27.4028 4.06555H27.4052Z"
        fill="none"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M19.0078 7.88861C18.8363 7.60777 18.4312 7.60529 18.2523 7.87867C16.3908 10.7342 10.2746 16.1247 9.89688 21.0952C9.45451 26.8982 13.5701 29.9601 18.635 29.9601C23.6999 29.9601 27.6266 26.0905 27.2464 21.0331C26.8686 15.998 20.8568 10.8808 19.0103 7.88861H19.0078Z"
        fill="none"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  ),
});

LiquidIcon.displayName = "LiquidIcon";
export { LiquidIcon };
